export const errorMessage = 'Нет информации';
